import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import BrandLogo from '../components/BrandLogo';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const token = searchParams.get('token');
    const pending = searchParams.get('pending');

    if (pending === 'true') {
      setStatus('pending');
      return;
    }

    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }

    api
      .verifyEmail(token)
      .then((data) => {
        setStatus('success');
        setMessage(data.message);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message);
        if (err.message && err.message.toLowerCase().includes('expired')) {
          setIsExpired(true);
        }
      });
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <BrandLogo />

        {status === 'pending' && (
          <>
            <div style={{ fontSize: 48, margin: '32px 0 16px' }}>📧</div>
            <h2 style={{ marginBottom: 8 }}>Check Your Inbox</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>
              We've sent a fresh verification link to your email address. Click the link in the email to activate your account.
            </p>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 24 }}>
              Didn't receive it? Check your spam folder, or{' '}
              <Link to="/login">go back and try signing in again</Link> to resend.
            </p>
            <Link to="/login" className="btn btn-secondary btn-block">
              Back to Sign In
            </Link>
          </>
        )}

        {status === 'verifying' && (
          <>
            <div style={{ fontSize: 48, margin: '32px 0 16px' }}>
              <span className="spinner" style={{ width: 40, height: 40 }} />
            </div>
            <p style={{ color: 'var(--text-secondary)' }}>Verifying your email...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, margin: '32px 0 16px' }}>✅</div>
            <h2 style={{ marginBottom: 8 }}>Email Verified!</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>{message}</p>
            <Link to="/login" className="btn btn-primary btn-block">
              Sign In
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, margin: '32px 0 16px' }}>{isExpired ? '⏰' : '❌'}</div>
            <h2 style={{ marginBottom: 8 }}>
              {isExpired ? 'Link Expired' : 'Verification Failed'}
            </h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>{message}</p>
            {isExpired ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <Link to="/signup" className="btn btn-primary btn-block">
                  Sign Up Again
                </Link>
                <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>
                  Already have an account? <Link to="/login">Sign in</Link> to resend verification.
                </p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <Link to="/login" className="btn btn-primary btn-block">
                  Sign In
                </Link>
                <Link to="/signup" className="btn btn-secondary btn-block">
                  Sign Up Again
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
